import React from 'react';
import { TFilterItem } from '../../../modules/copia/copia.type';
import styles from '../FloorBody/styles.module.scss';

function FromTo({ childs, handleChange }: any) {
  return (
    <div className={styles.FloorBody}>
      {childs.map((item: TFilterItem, index: number) => (
        <React.Fragment key={item.title || item.name}>
          <p className={styles.title}>{item.title || item.name}</p>
          <input
            type="number"
            value={item.value}
            onChange={(e: any) => handleChange(e, index)}
            className={styles.input}
          />
        </React.Fragment>
      ))}
    </div>
  );
}

export default FromTo;
